export class ContractFilter {

    description: string;
    type: any;
    classifications: any;

    constructor() {
    }
}
